import { TEDUrvalVisibility } from '../../../../../Types/UrvalTypes';
import { TEDSelectionVisibility } from '../../../../../globalQueryTypes';

interface IVisibilityLabel {
  SO: string;
  PO: string;
}

export const getVisibilityLabel = (
  visibility: TEDUrvalVisibility
): IVisibilityLabel => {
  if (visibility === TEDSelectionVisibility.gemensamt) {
    return { SO: 'Gemensamt urval', PO: 'Gemensamma urval' };
  } else if (visibility === TEDSelectionVisibility.grupp) {
    return { SO: 'Gruppurval', PO: 'Gruppurval' };
  } else if (visibility === TEDSelectionVisibility.privat) {
    return { SO: 'Mitt urval', PO: 'Mina urval' };
  } else if (visibility === TEDSelectionVisibility.standard) {
    return { SO: 'Standardurval', PO: 'Standardurval' };
  } else if (visibility === TEDSelectionVisibility.dbstandard) {
    return { SO: 'Standard grundurval', PO: 'Standard grundurval' };
  } else {
    return { SO: 'Övrigt sparat urval', PO: 'Övriga sparade urval' };
  }
};
